import React from 'react';
import { graphql, StaticQuery } from 'gatsby';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import Metadata from '../components/Metadata';
import Header from '../components/Header';
import Footer from '../components/Footer';

import FleetHeader from '../components/fleets/Header';

import './Page.scss';

const PageLayout = ({
  children,
  location,
  title = null,
  keywords = null,
  description = null,
  theme = null,
  headerColor = null,
  className = null,
}) => (
  <StaticQuery
    query={graphql`
      query LandingTitleQuery {
        site {
          siteMetadata {
            title
            keywords
            description
          }
        }
      }
    `}
    render={(data) => (
      <>
        <Metadata
          title={title ?? data.site.siteMetadata.title}
          description={description ?? data.site.siteMetadata.description}
          keywords={keywords ?? data.site.siteMetadata.keywords}
        />

        <FleetHeader />

        <main className={classnames('Page', className)}>{children}</main>
        <Footer location={location} />
      </>
    )}
  />
);

PageLayout.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.object,
};

export default PageLayout;
